import { render, staticRenderFns } from "./ProductEditCard.vue?vue&type=template&id=975159ea&"
import script from "./ProductEditCard.vue?vue&type=script&lang=js&"
export * from "./ProductEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports